import { getJson, postJson, withOptional, withValidate, withDone } from '@rad/utility/http';
export const getUsers = () => getJson('/api/users');
export const getUser = (id) => withOptional(getJson(`/api/users/${id}`));
export const createUser = (x) => withDone(withValidate(postJson('/api/users', x)))();
export const updateUser = (x) => withDone(withValidate(postJson(`/api/users/${x.id}`, x)))();
